exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-box-team {\n  background: #FFF;\n  height: 100%; }\n\n.content-box-team p {\n  color: #000;\n  padding: 5% 10px 0px 10px;\n  font-size: 1em;\n  font-weight: 500;\n  text-align: center; }\n\n@media (min-width: 992px) and (max-width: 1199px) {\n  .content-box-team p {\n    font-size: 0.9em; } }\n\n@media (max-width: 991px) {\n  .content-box-team {\n    margin-top: 30px; }\n  .media-row {\n    margin-bottom: 30px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.scss
// module id = 335
// module chunks = 1